// App home page
export const dashboardPath = () => '/dashboard';